<div
  *ngIf="(conflicts$ | async)?.length as conflictsCount"
  class="lpr-source-conflicts"
  data-testid="source-conflicts"
  matTooltip="{{ conflictsTooltipText$ | async }}"
  [matTooltipPosition]="'below'"
  [matTooltipClass]="'lpr-source-conflicts__tooltip'"
>
  {{ conflictsCount }}
  {{ (conflictsCount === 1 ? 'common.conflict' : 'common.conflicts') | t }}
  <sn-icon
    class="lpr-source-conflicts__icon"
    fontIcon="fa-triangle-exclamation"
    fontSet="fa"
  ></sn-icon>
</div>
